import { render, staticRenderFns } from "./manage-root.vue?vue&type=template&id=3faa8607&scoped=true"
import script from "./manage-root.vue?vue&type=script&lang=js"
export * from "./manage-root.vue?vue&type=script&lang=js"
import style0 from "./manage-root.vue?vue&type=style&index=0&id=3faa8607&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faa8607",
  null
  
)

export default component.exports